import {Reference} from 'smd-vue-scaffold';
import CountdownStartEndTimeMixin from '@/mixins/services/countdown-start-end-time-mixin';
import CouponCountdownTimer from '@/components/coupon-countdown-timer';
import ModalServiceOrderCancel from '@/components/services/modal-service-order-cancel';
import ModalReportIssue from '@/components/services/modal-report-issue';
import AttachedFileCard from '@/components/attached-file-card';
import PrescriptionCard from '@/components/prescription-card';
import ToastMixin from '@/mixins/toast-mixin';
import {mapGetters} from "vuex";
import {GETTER_FILES_FROM_DOC_PRESCRIPTIONS} from "@/store/types";

export default {
  mixins: [
    CountdownStartEndTimeMixin,
    ToastMixin,
  ],
  components: {
    CouponCountdownTimer,
    AttachedFileCard,
    PrescriptionCard,
  },
  props: {
    serviceOrder: {type: Object, required: true},
    watsonsBranches: {type: Array, required: true},
  },
  computed: {
    ...mapGetters({
      files: GETTER_FILES_FROM_DOC_PRESCRIPTIONS,
    }),
    coupon() {
      return this.serviceOrder.coupons[0];
    },
    availmentCode() {
      return this.coupon.latestavailmentcode || this.coupon.availmentcode;
    },
    selectedWatson() {
      return this.watsonsBranches.find(branch => branch.branchCode === this.availmentCode);
    },
    patientName() {
      const names = [this.serviceOrder.firstname, this.serviceOrder.middlename, this.serviceOrder.lastname];
      return names.join(' ');
    },
    redemptionCode() {
      const redemptionCode = this.coupon.redemptioncode;
      const availmentCode = this.availmentCode.padStart(4, '0');
      const MMDD = this.coupon.availmentdate.slice(5, 10).replace('-', '');

      return `${availmentCode} ${MMDD} ${redemptionCode}`;
    },
  },
  methods: {
    cancelOrder() {
      this.$modal.open({
        component: ModalServiceOrderCancel,
        size: Reference.SmdModalSizes.sm,
        position: 'detached auto-height',
        props: {
          orderid: this.serviceOrder.orderid,
        },
        onClose: ({success}) => {
          if (success) {
            this.$emit('refetch');
          }
        }
      });
    },
    reportIssue() {
      this.$modal.open({
        component: ModalReportIssue,
        size: Reference.SmdModalSizes.sm,
        position: 'detached auto-height',
        props: {
          orderid: this.serviceOrder.orderid,
        },
      });
    },
  },
  transConfig: {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Mins",
    "seconds": "Secs",
  },
}
